import { propEq } from 'ramda'
import React from 'react'

import { usePlaceTypes } from '../../../utils/helpers/placeTypes'
import Select from '../../../packages/kiti/components/form/Select'

const PlaceTypeSelect = ({ mergeOptions = [], returnObject, ...props }) => {
  const [placeTypes] = usePlaceTypes()

  let options = returnObject
    ? [...mergeOptions, ...placeTypes.map(item => ({ id: item.id, key: item.key, name: item.name, value: item.name }))]
    : [...mergeOptions, ...placeTypes.map(item => ({ id: item.key, name: item.name }))]
  return (
    <Select
      selectedLabel={placeTypes.find(propEq('key', props.value))?.name}
      options={options}
      selectOnlyId={returnObject ? false : true}
      {...props}
    />
  )
}

export default PlaceTypeSelect
